/**
 * Script for All Pages
 *
 * @author Space-Time Inc.
 * @version 2024-10-30
 */

/**
 * Minimum Viewport (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

(() => {
	const MIN_WIDTH = 360;

	const vp = document.querySelector('meta[name="viewport"]');
	function fn() {
		const v = window.outerWidth > MIN_WIDTH ? 'width=device-width,initial-scale=1' : `width=${MIN_WIDTH}`;
		if (vp.getAttribute('content') !== v) {
			vp.setAttribute('content', v);
		}
	}
	addEventListener('resize', throttle(fn), false);
	fn();

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
})();

/**
 * Back To Top
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

(() => {
	function init() {
		const OFFSET_Y = 0;

		const btn = document.getElementById('back-to-top');
		if (btn === null) return;
		const ph  = btn.parentElement;

		onScroll(scrollHandler);
		onResize(scrollHandler);
		if ('ontouchstart' in window) window.addEventListener('touchmove', scrollHandler);
		setTimeout(scrollHandler, 100);

		function scrollHandler() {
			// const btnR = btn.getBoundingClientRect();
			// const btnH = (btnR.bottom - btnR.top);

			const viewBottomY = window.innerHeight + OFFSET_Y/* - btnH*/;
			const footerTopY = ph.getBoundingClientRect().top;

			if (viewBottomY > footerTopY) {
				btn.style.transform = 'translateY(-' + (viewBottomY - footerTopY) + 'px)';
				btn.classList.remove('fixed');
			} else {
				btn.style.transform = '';
				btn.classList.add('fixed');
			}

			if (window.pageYOffset > window.innerHeight / 3) {
				btn.classList.remove('hidden');
			} else {
				btn.classList.add('hidden');
			}
		}
	}


	// -------------------------------------------------------------------------


	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	

	const resizeListeners = [];
	const scrollListeners = [];

	function onResize(fn, doFirst = false) {
		if (doFirst) fn();
		resizeListeners.push(throttle(fn));
	}

	function onScroll(fn, doFirst = false) {
		if (doFirst) fn();
		scrollListeners.push(throttle(fn));
	}

	document.addEventListener('DOMContentLoaded', () => {
		window.addEventListener('resize', () => {
			for (const l of resizeListeners) l();
		}, { passive: true });
		window.addEventListener('scroll', () => {
			for (const l of scrollListeners) l();
		}, { passive: true });
	});

	init();
})();

/**
 * Toggle Button
 *
 * @author Space-Time Inc.
 * @version 2022-07-11
 */

 document.addEventListener('DOMContentLoaded', () => {

	const btns = document.querySelectorAll('.stile *[class^="button"]');

	for (let i = 0; i < btns.length; i += 1) {
		if (isToggleButton(btns[i])) setEventListener(btns[i]);
	}

	function isToggleButton(btn) {
		if (!btn.href || btn.href[btn.href.length - 1] !== '#') return false;
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		return f.classList.contains('frame') || f.classList.contains('frame-alt');
	}

	function setEventListener(btn) {
		btn.classList.add('toggle');
		initFrame(btn);
		btn.addEventListener('click', (e) => {
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				setFrameVisible(btn, false);
			} else {
				btn.classList.add('active');
				setFrameVisible(btn, true);
			}
			e.preventDefault();
		});
	}

	function initFrame(btn) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		f.style.display = 'none';
		f.classList.add('hidden');
		setTimeout(() => { f.style.display = ''; }, 10);
	}

	function setFrameVisible(btn, visible) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		if (visible) {
			f.classList.remove('hidden');
		} else {
			f.classList.add('hidden');
		}
	}

});

/**
 * Script for Site Header
 *
 * @author Space-Time Inc.
 * @version 2023-01-24
 */

window.addEventListener('DOMContentLoaded', () => {
	// Hamburger Menu

	const menu     = document.querySelector('.part-hamburger');
	const btnOpen  = document.getElementById('button-open-menu');
	const btnClose = document.getElementById('button-close-menu');

	btnOpen.addEventListener('click', () => {
		menu.classList.toggle('visible');
		document.body.classList.add('is-menu-open');
	});
	btnClose.addEventListener('click', () => {
		menu.classList.toggle('visible');
		document.body.classList.remove('is-menu-open');
	});

	// Behavior in the Front Page

	const shw = document.querySelector('.site-header-wrapper');
	const sh  = document.querySelector('.site-header');

	if (!shw) return;

	let lastIsSticky = null; // 直前のsticky状態を保存

	function goToNormal(flag) {
		// メニューオープン中は何もしない
		if (menu && menu.classList.contains('visible')) return;

		// 前回と同じ状態なら何もしない
		if (lastIsSticky === flag) return;

		lastIsSticky = flag;

		shw.classList.add('hidden');

		setTimeout(() => {
			if (flag) {
				shw.classList.add('sticky');
			} else {
				shw.classList.remove('sticky');
			}
			shw.classList.remove('hidden');
		}, 100);
	}

	// ✅ スクロール時に状態が変化したときのみ goToNormal を呼ぶ
	function handleScroll() {
		const shouldBeSticky = window.scrollY > 0;
		goToNormal(shouldBeSticky);
	}

	window.addEventListener('scroll', throttle(handleScroll));

	// 初期状態も反映
	handleScroll();

	function fn() {
		document.body.style.setProperty('--site-header-height', sh.offsetHeight + 'px');
	}
	addEventListener('resize', throttle(fn), false);
	fn();

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
});
/**
 * Image Comparator
 *
 * @author Space-Time Inc.
 * @version 2024-10-30
 */

document.addEventListener('DOMContentLoaded', () => {
	const rs = document.getElementsByClassName('image-comparator');
	for (const r of rs) {
		const d = r.querySelector('.image-comparator-divider');
		if (d) {
			new ImageComparator(r, d);
		}
	}
});

class ImageComparator {

	#root;

	constructor(root, div) {
		this.#root = root;

		this.setSize();
		window.addEventListener('resize', () => this.setSize(), false);

		div.draggable = false
		div.addEventListener('pointermove', e => {
			if (e.buttons) {
				div.setPointerCapture(e.pointerId);

				const x    = div.offsetLeft + e.movementX;
				const maxX = this.#root.clientWidth;

				const cx = Math.max(0, Math.min(x, maxX));
				this.#root.style.setProperty('--position', `${cx}px`);
			}
		});

		this.#root.classList.add('is-active');
	}

	setSize() {
		const w = this.#root.clientWidth;
		this.#root.style.setProperty('--width', `${w}px`);
		this.#root.style.setProperty('--position', `${w / 2}px`);
	}

}
